import { ReactTFC } from "../../../../../utils/fp/missing-ts-parts";
import React from "react";

import { css } from "@emotion/react";

import { CSS_MQ } from "../../../../../styles/breakpoints";
import { MailSvg } from "../../../../shop-layouts/checkout-page-layout/CheckoutComponent/shared/form/FormSvgIcons";
import { CSS_COLORS } from "../../../../../styles/styles-css-variables";
import { fontColor, FONTS, fontSize } from "../../../../../styles/fonts";

export const MailInput: ReactTFC<{
  email: string;
  setEmail: React.Dispatch<React.SetStateAction<string>>;
  placeholderLabel: string;
}> = props => {
  return (
    <div
      css={css`
        position: relative;

        ${CSS_MQ.atMostSm} {
          width: 100%;
        }
      `}
    >
      <span
        css={css`
          width: 55px;
          height: 100%;

          position: absolute;
          display: flex;
          justify-content: center;
          align-items: center;

          top: 0;
          left: 0;

          pointer-events: none;
        `}
      >
        <MailSvg
          css={css`
            width: 20px;
            height: 13px;
          `}
        />
      </span>
      <input
        placeholder={props.placeholderLabel}
        type={"email"}
        required={true}
        value={props.email}
        onChange={e => {
          const { value } = e.target;

          props.setEmail(value);
        }}
        css={[
          FONTS.SwarovskiFutura300,
          fontColor.black,
          fontSize.x2,
          css`
            height: 50px;
            padding-top: 5px;

            width: 100%;
            ${CSS_MQ.atLeastMd} {
              width: 420px;
              max-width: 100%;
            }

            padding-left: 55px;
            padding-right: 20px;

            border: 1px solid ${CSS_COLORS.Grey4};
            border-radius: 4px;

            &:focus,
            &:active {
              border: 1px solid ${CSS_COLORS.Green};
              outline: none !important;
            }
          `,
        ]}
      />
    </div>
  );
};
